var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgR(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 131,
    viewBox: "0 0 184 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130.539 0.5C158.842 0.500033 181.758 20.9094 181.758 45.8799V48.9141C181.758 67.0532 169.684 82.7757 152.222 90.0391L151.616 90.291L152.02 90.8086L182.976 130.5H140.591L112.543 94.5156L112.393 94.3223H35.877V94.7939H35.377V130.472H0.5V0.5H130.539ZM35.377 65.3564H139.734C143.631 65.3563 146.881 62.5535 146.881 58.96V35.8916C146.881 32.2981 143.631 29.4952 139.734 29.4951H35.377V65.3564Z",
    fill: "#6941E6",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgR);
export default __webpack_public_path__ + "static/media/r.dd15348c3f4dedc2d82dc0c623cb8bd5.svg";
export { ForwardRef as ReactComponent };